<template>
  <div>
    <board :boardId="boards[0]" />
    <controllers :name=roomName />
  </div>
</template>

<script>
import Board       from './board'
import Controllers from './controllers'

export default {
  name: 'BriefingBoard',
  data () {
    return {
      roomName : 'test',
      boards   : ['test1']
    }
  },
  components: {
    Board,
    Controllers
  },
  mounted () {
    this.$sockets.of('/').emit('joinRoom', this.$route.params.id)
  },
  sockets: {
    roomData (data) {
      this.roomName = data.name
      this.boards = data.boards
    },
    joinRoom (roomId) {
      this.$sockets.of('/canvas').emit('joinRoom', roomId)
      this.$sockets.of('/object').emit('joinRoom', roomId)
      this.$sockets.of('/image').emit('joinRoom', roomId)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/room/index.vue